'use strict'

const pageContentsVerticalNavigation = require('../../common/components/page-contents-vertical-navigation');

exports.privacy = function () {
    pageContentsVerticalNavigation.start($('*[data-module=highlight-active-section-heading]'))
}